import { useContext, useState } from "react";
import "./main-page.css";
import ProductInfoCard from "./productInfoCard";
import { cartContext } from "../App";
import Header from "./header";
import BottomCart from "./bottom-cart";
import { Link, useNavigate } from "react-router-dom";
import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css';
import HeaderMain from "./headerMain";
import LoginPopUp from "./subcomponents/login-popup";

export default function MainPage() {
 
    const [showPopup, setShowPopup] = useState(false);
    const { productDataList, extraData, maxAmountReached, deferredPrompt, showDownloadButton, changeInstallVariable } = useContext(cartContext);
    const homeOfficeData = []
    const cleaningEssentialsData = []
    const personalCareData = []
    const dryFruitsNutsData = []
    const stationaryData = []
    const fruitsVegetablesData = []
    const gadgetsData = []
    const poojaData = []
    const snacksDrinksData = []
    productDataList.map((item) => {
        if (extraData.data.categories['home'].includes(item.data.category)) {
            homeOfficeData.push(item)
        } else if (extraData.data.categories['cleaning-essentials'].includes(item.data.category)) {
            cleaningEssentialsData.push(item)
        } else if (extraData.data.categories['personal-care'].includes(item.data.category)) {
            personalCareData.push(item)
        } else if (extraData.data.categories['dry-fruits-nuts'].includes(item.data.category)) {
            dryFruitsNutsData.push(item)
        } else if (extraData.data.categories['stationary'].includes(item.data.category)) {
            stationaryData.push(item)
        } else if (extraData.data.categories['fruits-vegetables'].includes(item.data.category)) {
            fruitsVegetablesData.push(item)
        } else if (extraData.data.categories['pooja-needs'].includes(item.data.category)) {
            poojaData.push(item)
        } else if (extraData.data.categories['snacks-drinks'].includes(item.data.category)) {
            snacksDrinksData.push(item)
        }
        if (item.data.category === 'gadgets') {
            gadgetsData.push(item)
        } 
    });
    // const cleaningEssentialsData = productDataList.filter((item) => item.data.category === 'cleaning-essentials');
    // const personalCareData = productDataList.filter((item) => extraData.data.categories['personal-care'].includes(item.data.category));
    // const gadgetsData = productDataList.filter((item) => item.data.category === 'gadgets');
    // const dailyUseData = productDataList.filter((item) => item.data.category === 'daily-use');
    // const studentsData = productDataList.filter((item) => item.data.category === 'stationary' || item.data.category === 'gadgets');
    const min50Discount = productDataList.filter((item) => Number(item.data.discount) >= 50 );

    const settings = {
        dots: false, // Show navigation dots
        infinite: extraData.data.images.length > 1, // Infinite looping
        speed: 500, // Transition speed
        slidesToShow: Math.min(extraData.data.images.length, 1), // Number of slides visible
        slidesToScroll: 1, // Number of slides to scroll
        autoplay: true, // Auto-slide
        autoplaySpeed: 10000, // Auto-slide speed in ms
        arrows: true, // Show navigation arrows
    };

    const handleAddToHomeScreen = () => {
        if (deferredPrompt) {
          deferredPrompt.prompt();
          deferredPrompt.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === 'accepted') {
              console.log('User added the app to their home screen');
            } else {
              console.log('User dismissed the prompt');
            }
              changeInstallVariable();
          });
        }
    };

    setTimeout(() => {
        setShowPopup(true);
    }, 4000)
    
    return (
        <>
            {
                maxAmountReached && (
                    <div className="max-amount-reached">
                        <p className="max-amount-reached-text">Maximum Quantity Reached!</p>
                    </div>
                )
            }
            <HeaderMain />
            { showPopup && <LoginPopUp />}
            <div style={{ display:'flex', justifyContent:'center'}}>
                <div className="poster">
                    <Slider {...settings}>
                        {
                            extraData.data.images.map((image, index) => (
                                <img key={ index } className='poster-img' src={ image }/>
                            ))
                        }
                    </Slider>
                    
                </div>
            </div>

            <div className="horizonatal-scroll">
                <div className="name-see-all">
                    <p className="tag-name">Fresh Fruits & Vegetables</p>
                    <Link to='/display-products' state={{category:'', name:'Fresh Fruits & Vegetables', productList: fruitsVegetablesData}} className="see-all">See all&#62;</Link>
                </div>
                <div className="horizontal-list">
                    <ProductInfoCard dataList={fruitsVegetablesData.slice(0,15)} />
                </div>
            </div>

            <div className="horizonatal-scroll">
                <div className="name-see-all">
                    <p className="tag-name">Snacks & Drinks</p>
                    <Link to='/display-products-category'
                        state={{
                            category: 'chips-namkeen,biscuits-cookies,sweets-chocolates,drinks-juices',
                            name: 'Snacks & Munchies',
                            categoryName:'Chips & Namkeen,Biscuits & Cookies,Sweets & Chocolates,Drinks & Juices'
                        }}
                        className="see-all">See all&#62;</Link>
                </div>
                <div className="horizontal-list">
                    <ProductInfoCard dataList={snacksDrinksData.slice(0,15)} />
                </div>
            </div>

            <div className="horizonatal-scroll">
                <div className="name-see-all">
                    <p className="tag-name">Limited Time Deal – Min. 50% OFF!</p>
                    <Link to='/display-products' state={{category:'', name:'Minimum 50% OFF Sale', productList: min50Discount}} className="see-all">See all&#62;</Link>
                </div>
                <div className="horizontal-list">
                    <ProductInfoCard dataList={min50Discount.slice(0,15)} />
                </div>
            </div>

            {/* color used  background #E3FFE5 */}
            <p className="tag-name" style={{marginLeft:'15px'}}>Shop By Category</p>
            <div className="shop-by-categories">
                <div className="categories">
                    <Link to='/display-products-category' state={{ category: 'atta,dal,rice,atta-rice-dal-others', name: 'Atta, Rice & More', categoryName:'Atta,Dal,Rice,Others' }} style={{textDecoration:'none'}}>
                        <img src='/category/atta-rice-more.jpg' className="category-img" style={{ width: '70px', height: '70px', borderRadius: '10px' }} />
                        <p style={{maxWidth:'70px', color:'black', fontSize:'10px', textAlign:'center', marginTop:'5px'}}>Atta, Rice & More</p>
                    </Link>
                </div>
                <div className="categories">
                    <Link to='/display-products-category' state={{ category: 'salt,sugar,jaggery,sweetners-others', name: 'Salt, Sugar & Jaggery', categoryName:'Salt,Sugar,Jaggery,Others' }} style={{textDecoration:'none'}}>
                        <img src='/category/salt-sugar.jpg' className="category-img" style={{ width: '70px', height: '70px', borderRadius: '10px' }} />
                        <p style={{maxWidth:'70px', color:'black', fontSize:'10px', textAlign:'center', marginTop:'5px'}}>Salt, Sugar & Jaggery</p>
                    </Link>
                </div>
                <div className="categories">
                    <Link to='/display-products-category' state={{ category: 'powder-masala,whole-spices,oil,refined-oil,ghee,chutneys,pickles', name: 'Masala Oil & More', categoryName:'Powdered Masala,Whole Spices,Oil,Refined Oil,Ghee,Chutneys,Pickles' }} style={{textDecoration:'none'}}>
                        <img src='/category/masala-oil.jpg' className="category-img" style={{ width: '70px', height: '70px', borderRadius: '10px' }} />
                        <p style={{maxWidth:'70px', color:'black', fontSize:'10px', textAlign:'center', marginTop:'5px'}}>Masala, Oil & More</p>
                    </Link>
                </div>
                <div className="categories">
                    <Link to='/display-products-category'
                        state={{
                            category: 'freshners,bathroom-essentials,party-needs,home-needs',
                            name: 'Home and Office',
                            categoryName: 'Freshners & Repellant,Bathroom Essentials,Party Needs,Home Needs'
                        }}
                        style={{ textDecoration: 'none' }}>
                        <img src='/category/home.jpg' className="category-img" style={{ width: '70px', height: '70px', borderRadius: '10px' }} />
                        <p style={{maxWidth:'70px', color:'black', fontSize:'10px', textAlign:'center', marginTop:'5px'}}>Home & Office</p>
                    </Link>
                </div>
                <div className="categories">
                    <Link to='/display-products-category'
                        state={{
                            category: 'face-wash,body-lotion,cream,perfume,face-mask,toothpaste,toothbrush,shampoo,hair-oil,soap,hair-color,hand-wash,beauty',
                            name: 'Personal Care',
                            categoryName: 'Face Wash,Body Lotion,Face Cream,Perfumes & Deo,Facial Kit & More,ToothPaste,ToothBrush,Shampoo,Hair Oil,Soap,Hair Colour,Hand Wash,Beauty & Others'
                        }}
                        style={{ textDecoration: 'none' }}>
                        <img src='/category/personal-care.jpg' className="category-img" style={{ width: '70px', height: '70px', borderRadius: '10px' }} />
                        <p style={{maxWidth:'70px', color:'black', fontSize:'10px', textAlign:'center', marginTop:'5px'}}>Personal Care</p>
                    </Link>
                </div>
                
                <div className="categories">
                    <Link to='/display-products-category'
                        state={{
                            category: 'cashew,raisin,pista,dates,makhana,dry-fruits-others',
                            name: 'Dry Fruits & Nuts',
                            categoryName: 'Cashew,Raisin,Pista,Dates,Makhana,Other Dry Fruits'
                        }}
                        style={{ textDecoration: 'none' }}>
                        <img src='/category/dry-fruits.jpg' className="category-img" style={{ width: '70px', height: '70px', borderRadius: '10px' }} />
                        <p style={{maxWidth:'70px', color:'black', fontSize:'10px', textAlign:'center', marginTop:'5px'}}>Dry Fruits & Nuts</p>
                    </Link>
                </div>
                <div className="categories">
                    <Link to='/display-products-category'
                        state={{
                            category: 'notebooks,pens,school-office-supply,everyday-use,files-folder',
                            name: 'Stationary',
                            categoryName:'Notebooks,Pencils & Pens,School & Office Supply,EveryDay Use,Files & Folders'
                        }}
                        style={{ textDecoration: 'none' }}>
                        <img src='/category/stationary.jpg' className="category-img" style={{ width: '70px', height: '70px', borderRadius: '10px' }} />
                        <p style={{maxWidth:'70px', color:'black', fontSize:'10px', textAlign:'center', marginTop:'5px'}}>Stationary</p>
                    </Link>
                </div>
                <div className="categories">
                    <Link to='/display-products-category'
                        state={{
                            category: 'chips-namkeen,biscuits-cookies,sweets-chocolates,drinks-juices',
                            name: 'Snacks & Munchies',
                            categoryName:'Chips & Namkeen,Biscuits & Cookies,Sweets & Chocolates,Drinks & Juices'
                        }}
                        style={{ textDecoration: 'none' }}>
                        <img src='/category/snacks-drink.jpg' className="category-img" style={{ width: '70px', height: '70px', borderRadius: '10px' }} />
                        <p style={{maxWidth:'70px', color:'black', fontSize:'10px', textAlign:'center', marginTop:'5px'}}>Snacks & Drinks</p>
                    </Link>
                </div>
                

            </div>

            <p className="tag-name" style={{marginLeft:'15px'}}>Dairy & Breakfast</p>
            <div className="shop-by-categories">
                <div className="categories">
                    <Link to='/display-products' state={{ category: 'milk', name: 'Milk & Dairy' }} style={{textDecoration:'none'}}>
                        <img src='/category/milk.jpg' className="category-img" style={{ width: '70px', height: '70px', borderRadius: '10px' }} />
                        <p style={{maxWidth:'70px', color:'black', fontSize:'10px', textAlign:'center', marginTop:'5px'}}>Milk & Dairy</p>
                    </Link>
                </div>
                <div className="categories">
                    <Link to='/display-products' state={{ category: 'breads', name: 'Bread & Buns' }} style={{textDecoration:'none'}}>
                        <img src='/category/bread.jpg' className="category-img" style={{ width: '70px', height: '70px', borderRadius: '10px' }} />
                        <p style={{maxWidth:'70px', color:'black', fontSize:'10px', textAlign:'center', marginTop:'5px'}}>Bread & Buns</p>
                    </Link>
                </div>
                <div className="categories">
                    <Link to='/display-products' state={{ category: 'breakfast-cereals', name: 'Breakfast & Cereals' }} style={{textDecoration:'none'}}>
                        <img src='/category/breakfast.jpg' className="category-img" style={{ width: '70px', height: '70px', borderRadius: '10px' }} />
                        <p style={{maxWidth:'70px', color:'black', fontSize:'10px', textAlign:'center', marginTop:'5px'}}>Breakfast & Cereals</p>
                    </Link>
                </div>
                <div className="categories">
                    <Link to='/display-products' state={{ category: 'jams-spread', name: 'Jams & Spreads' }} style={{textDecoration:'none'}}>
                        <img src='/category/jam-spread.jpg' className="category-img" style={{ width: '70px', height: '70px', borderRadius: '10px' }} />
                        <p style={{maxWidth:'70px', color:'black', fontSize:'10px', textAlign:'center', marginTop:'5px'}}>Jams & Spreads</p>
                    </Link>
                </div>

            </div>

            <p style={{fontSize:'16px', fontWeight:'bold', marginLeft:'20px'}}>Fruits & Vegetables</p>
            <div className="color-adv-box">
                <Link to='/display-products' state={{ category: 'fruits,exotics', name: 'Fruits' }}>
                    <div>
                        <img src="/category/fruits.jpg" style={{width:'150px', borderRadius:'25px'}}/>
                    </div>
                </Link>
                <Link to='/display-products' state={{ category: 'vegetables,vegetables-others', name: 'Vegetables' }}>
                    <div>
                        <img src="/category/vegetables.jpg" style={{width:'150px', borderRadius:'25px'}}/>
                    </div>
                </Link>    
            </div>

            <div className="horizonatal-scroll">
                <div className="name-see-all">
                    <p className="tag-name">Personal Care</p>
                    <Link to='/display-products-category'
                        state={{
                            category: 'face-wash,body-lotion,cream,perfume,face-mask,toothpaste,toothbrush,shampoo,hair-oil,soap,hair-color,hand-wash,beauty',
                            name: 'Personal Care',
                            categoryName: 'Face Wash,Body Lotion,Face Cream,Perfumes & Deo,Facial Kit & More,ToothPaste,ToothBrush,Shampoo,Hair Oil,Soap,Hair Colour,Hand Wash,Beauty & Others'
                        }}
                        className="see-all">See all&#62;</Link>
                </div>
                <div className="horizontal-list">
                    <ProductInfoCard dataList={personalCareData} />
                </div>
            </div>

            <div className="horizonatal-scroll">
                <div className="name-see-all">
                    <p className="tag-name">Daily Pooja Essentials</p>
                    <Link to='/display-products' state={{category:'', name:'Daily Pooja Essentials', productList: poojaData}} className="see-all">See all&#62;</Link>
                </div>
                <div className="horizontal-list">
                    <ProductInfoCard dataList={poojaData} />
                </div>
            </div>

            <p style={{fontSize:'16px', fontWeight:'bold', marginLeft:'20px'}}>Featured</p>
            <div className="color-adv-box">
                <Link to='/display-products-category'
                    state={{
                        category: 'chips-namkeen,biscuits-cookies,sweets-chocolates,drinks-juices',
                        name: 'Snacks & Munchies',
                        categoryName:'Chips & Namkeen,Biscuits & Cookies,Sweets & Chocolates,Drinks & Juices'
                    }}
                >
                    <div>
                        <img src="/adv-img/snacks-featured-4754.jpg" style={{width:'120px', borderRadius:'10px'}}/>
                    </div>
                </Link>
                <Link to='/display-products' state={{ category: 'face-wash', name: 'Face Washes' }}>
                    <div>
                        <img src="/adv-img/facewash.jpg" style={{width:'120px', borderRadius:'10px'}}/>
                    </div>
                </Link>
                <Link to='/display-products' state={{ category: 'perfume', name: 'Fragrances' }}>
                    <div>
                        <img src="/adv-img/fragrance.jpg" style={{width:'120px', borderRadius:'10px'}}/>
                    </div>
                </Link>    
            </div>

            <div className="horizonatal-scroll" style={{backgroundColor:'rgb(207, 239, 190)', width:'100%', margin:'5px 0 0 0', padding:'0 0 5px 0'}}>
                <div className="name-see-all" >
                    <p className="tag-name" style={{display:'flex', alignItems:'center', fontSize:'18px', marginLeft:'15px'}}>For Students</p>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
                        {/* <img src="/students2.png" style={{ height: '100px'}}></img> 
                        <img src="/student.png" style={{ height: '100px' }}></img>                         */}
                        <img src="/adv-img/student-grp.png" style={{ height: '110px' }}></img>                        
                    </div>

                </div>
                <div className="horizontal-list">
                    <ProductInfoCard dataList={stationaryData} />
                </div>
            </div>
            <Link to='/display-products-category'
                state={{
                    category: 'notebooks,pens,school-office-supply,everyday-use,files-folder',
                    name: 'Stationary',
                    categoryName:'Notebooks,Pencils & Pens,School & Office Supply,EveryDay Use,Files & Folders'
                }}
                style={{ textDecoration: 'none' }}>
                <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', padding:'0 10px', background:'#2c5f2d' }}>
                    <p className="see-all" style={{ color:'white', fontSize:'16px' }}>See All Products</p>  
                    <p style={{color:'white'}}>&#62;</p>
                </div>
            </Link>
            <Link to='/display-products-category'
                state={{
                    category: 'chips-namkeen,biscuits-cookies,sweets-chocolates,drinks-juices',
                    name: 'Snacks & Munchies',
                    categoryName:'Chips & Namkeen,Biscuits & Cookies,Sweets & Chocolates,Drinks & Juices'
                }}
            >
                <div>
                    <img src="/adv-img/snacks&munchies.jpg" style={{width:'98%', marginLeft:'5px', borderRadius:'10px', marginTop:'10px'}} />
                </div>
            </Link>

            <div className="horizonatal-scroll">
                <div className="name-see-all">
                    <p className="tag-name">Cleaning Essentials</p>
                    <Link to='/display-products-category'
                        state={{
                            category: 'detergent,liquid-detergent,detergent-bar,dish-wash,disinfectants-cleaner,cleaning-tools,utensils',
                            name: 'Cleaning Essentials',
                            categoryName: 'Detergents,Liquid Detergents,Detergent Bars,Dish Wash,Disinfectants & Cleaners,Cleaning Tools,Utensils'
                        }}
                        className="see-all">See all&#62;</Link>
                </div>
                <div className="horizontal-list">
                    <ProductInfoCard dataList={cleaningEssentialsData.slice(0,15)} />
                </div>
            </div>
            
            <div className="horizonatal-scroll">
                <div className="name-see-all">
                    <p className="tag-name">Home & Office</p>
                    <Link to='/display-products-category'
                        state={{
                            category: 'freshners,bathroom-essentials,party-needs,home-needs',
                            name: 'Home and Office',
                            categoryName: 'Freshners & Repellant,Bathroom Essentials,Party Needs,Home Needs'
                        }}
                        className="see-all">See all&#62;
                    </Link>
                </div>
                <div className="horizontal-list">
                    <ProductInfoCard dataList={homeOfficeData.slice(0,15)} />
                </div>
            </div>
            {/* <div className="poster-school">
                <Link to='/display-products' state={{category:'notebooks,pens,markers,school-office-supply,everyday-use,files-folder', name:'Stationary'}}><img src="/school-poster.jpg" style={{width:'97%', borderRadius:'10px', marginLeft:'6px', height:'150px', objectFit:'cover', objectPosition:'top'}}></img></Link>  
            </div> */}
            <div className="horizonatal-scroll">
                <div className="name-see-all">
                    <p className="tag-name">Gadgets</p>
                    <Link to='/display-products' state={{category:'gadgets', name:'Gadgets'}} className="see-all">See all&#62;</Link>
                </div>
                <div className="horizontal-list">
                    <ProductInfoCard dataList={gadgetsData.slice(0,15)} />
                </div>
            </div>

            <div className='footer-section'>
                <div>
                    <p style={{color:'black', fontSize:'18px', fontWeight:'bold', marginBottom: '5px', marginTop: '5px'}}>Didn't find an item?</p>
                    <p style={{ color: 'black', fontSize: '13px', marginTop: '5px', fontSize: '12px' }}>
                        Want something we don’t have? Request it here, and we’ll bring it to you, as soon as possible!
                    </p>
                    <Link to='/request-product' style={{textDecoration: 'none'}}><div className="app-download-btn">Request Product</div></Link>
                </div>
                <div>
                    <img src='/icons/add-product.png' alt="Request-Product" style={{height:'150px'}}/>
                </div>
            </div>

            <BottomCart />
        </>    
    );
}
